import React, { useState } from 'react';
import {
    FaMapMarkerAlt, FaArrowRight, FaCalendarAlt, FaStore,
    FaClipboardCheck, FaImage, FaReply, FaInfoCircle, FaTimes
} from "react-icons/fa";

const ComplaintPublicDetails = ({ complaint, onBack }) => {
    const [selectedImg, setSelectedImg] = useState(null);

    return (
        <div className="animate-fade-in text-end">
            <div className={`d-flex justify-content-between align-items-center mb-4 p-3 rounded-4 shadow-sm border-end border-5 bg-dark bg-opacity-25 ${complaint.isProcessed ? 'border-success' : 'border-warning'}`}>
                <div>
                    <h5 className="fw-bold mb-0 text-white">
                        {complaint.isProcessed ? 'تمت معالجة الشكوى' : 'الشكوى قيد المراجعة حالياً'}
                    </h5>
                    <small className="text-white-50">رقم المرجع: {complaint.complaintUid?.split('-')[0].toUpperCase()}</small>
                </div>
                <button onClick={onBack} className="btn btn-outline-light rounded-pill px-3 btn-sm">
                    <FaArrowRight className="ms-2" /> العودة للبحث
                </button>
            </div>

            <div className="row g-4">
                <div className="col-lg-7">
                    <div className="card border-0 shadow-sm rounded-4 mb-4 bg-dark bg-opacity-50 text-white">
                        <div className="card-header border-bottom border-white border-opacity-10 py-3 d-flex align-items-center">
                            <FaInfoCircle className="text-info ms-2" />
                            <h6 className="mb-0 fw-bold">محتوى البلاغ المقدم</h6>
                        </div>
                        <div className="card-body p-4">
                            <p className="lh-lg mb-4" style={{ whiteSpace: 'pre-line' }}>{complaint.complaintText}</p>
                            <div className="d-flex flex-wrap gap-3 pt-3 border-top border-white border-opacity-10 text-white-50 small">
                                <span><FaCalendarAlt className="ms-1" /> التقديم: {new Date(complaint.createdAtUtc).toLocaleDateString('ar-SY')}</span>
                                {complaint.isProcessed && (
                                    <span className="text-success"><FaClipboardCheck className="ms-1" /> المعالجة: {new Date(complaint.processedAtUtc).toLocaleDateString('ar-SY')}</span>
                                )}
                            </div>
                        </div>
                    </div>

                    {complaint.isProcessed && (
                        <div className="card border-0 shadow-sm rounded-4 mb-4 border-top border-success border-5 bg-dark bg-opacity-50 text-white">
                            <div className="card-header border-bottom border-white border-opacity-10 py-3 d-flex align-items-center">
                                <FaReply className="text-success ms-2" />
                                <h6 className="mb-0 fw-bold">الرد الرسمي من الإدارة</h6>
                            </div>
                            <div className="card-body p-4">
                                <div className="p-3 rounded-4 bg-success bg-opacity-10 border border-success border-opacity-20">
                                    {complaint.staffResponse || "تمت معالجة الشكوى واتخاذ الإجراءات القانونية اللازمة بحق المنشأة المخالفة."}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="col-lg-5">
                    <div className="card border-0 shadow-sm rounded-4 mb-4 bg-dark bg-opacity-50 text-white text-center">
                        <div className="card-body p-4">
                            <div className="bg-info bg-opacity-10 p-3 rounded-circle d-inline-block mb-3">
                                <FaStore className="text-info fs-4" />
                            </div>
                            <h6 className="fw-bold mb-1">{complaint.establishment?.name}</h6>
                            <p className="text-white-50 small mb-0">
                                <FaMapMarkerAlt className="ms-1" /> {complaint.establishment?.governorate} - {complaint.establishment?.city}
                            </p>
                        </div>
                    </div>

                    <div className="card border-0 shadow-sm rounded-4 bg-dark bg-opacity-50 text-white">
                        <div className="card-header border-bottom border-white border-opacity-10 py-3">
                            <h6 className="mb-0 fw-bold"><FaImage className="ms-2 text-info" /> المرفقات</h6>
                        </div>
                        <div className="card-body p-3">
                            <div className="row g-2">
                                {complaint.photos?.length > 0 ? complaint.photos.map((photo, i) => (
                                    <div key={i} className="col-6">
                                        <div className="img-thumbnail-wrapper" onClick={() => setSelectedImg(photo.url)}>
                                            <img src={photo.url} alt="Evidence" className="img-fluid rounded-3" />
                                        </div>
                                    </div>
                                )) : <div className="text-center py-3 text-white-50 small">لا توجد صور مرفقة</div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedImg && (
                <div className="lightbox-overlay" onClick={() => setSelectedImg(null)}>
                    <div className="lightbox-content" onClick={e => e.stopPropagation()}>
                        <button className="close-btn" onClick={() => setSelectedImg(null)}><FaTimes /></button>
                        <img src={selectedImg} alt="Evidence" className="img-fluid rounded-4 shadow-lg" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ComplaintPublicDetails;